/**
 * Free-text search for the appointment list tabs.
 *
 * Every appointment tab shows the same rows split across a scheduled /
 * completed / voided trio of tables, so the filter is built once per query and
 * applied to each table's rows. The caller names the searchable fields, which
 * always include the Job Code / Deployment ID.
 */
export function makeAppointmentFilter<T>(
  query: string,
  fields: (row: T) => (string | null | undefined)[]
): (rows: T[]) => T[] {
  const needle = query.trim().toLowerCase();
  return (rows: T[]) => {
    if (!needle) return rows;
    return rows.filter((row) => fields(row).some((value) => (value ?? '').toLowerCase().includes(needle)));
  };
}
